<template>
  <div class="d-flex flex-column align-center justify-center">

    <template v-if="loading || internalLoading">
      <slot name="loading">
        <v-progress-circular indeterminate color="primary" :size="80">
        </v-progress-circular>
      </slot>
    </template>

    <template v-else>
      <slot :data="data">
        <slot name="title">
          <h3 v-text="title" />
        </slot>
        <slot name="description">
          <p v-text="description" />
        </slot>
        <slot name="chart" :data="data">
          slot:chart
        </slot>
      </slot>
    </template>

  </div>
</template>


<script>
export default {
  name: "SlottedDataChart",
  model: {
    prop: 'data',
    event: 'change',
  },
  props: {
    refreshKey: [String, Number],
    data: {
      type: [Array, Object, String, Number],
      default: () => [],
    },
    getDataFunction: Function,
    title: String,
    description: String,
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: { },

  data() {
    return {
      internalLoading: false,
    };
  },

  mounted() { 
    this.getData();
  },

  methods: { 
    getData() {
      if(this.getDataFunction != undefined){
        this.internalLoading = true;
        this.getDataFunction()
          .then((data) => {
            this.$emit('change', data);
          }).catch((error) => {
            console.error('getData', error);
          })
          .finally(() => {
            this.internalLoading = false;
          });
      }
    },
  },

  computed: {},

  watch: {
    refreshKey: function () {
      this.getData();
    },
  },
};
</script>


<style lang='scss'>
</style>
